/**
 * Группы статусов для интерфейса. Правда о переходах на сервере; здесь решается только,
 * что показать: экран ожидания, доставку или закрытый заказ.
 */
const set = (...items: string[]): ReadonlySet<string> => new Set(items);

export const OrderStatusGroup = {
  awaitingPayment: set('PAYMENT_PENDING'),
  inWarehouse: set('PAID', 'PICKING', 'PICKED'),
  onTheWay: set('IN_TRANSIT'),
  finished: set('DELIVERED', 'CANCELLED', 'CANCELLED_LATE', 'RETURN', 'REFUNDED'),
  cancelled: set('CANCELLED', 'CANCELLED_LATE', 'REFUNDED'),
  delivered: set('DELIVERED'),
  /** Сборка ещё не закончена: собранное количество строки ещё в работе. */
  beforePicked: set('PAYMENT_PENDING', 'PAID', 'PICKING'),
  /** Клиент отменяет сам только до сборки: дальше отменяет оператор. */
  clientCancellable: set('PAYMENT_PENDING', 'PAID'),
  /** Карта курьера видна, пока заказ в пути. */
  trackable: set('IN_TRANSIT'),

  isActive(status: string): boolean {
    return !this.finished.has(status);
  },

  /** Шаг пути заказа для полосы прогресса: оплачен, собирается, в пути, вручён. */
  stage(status: string): number {
    if (this.awaitingPayment.has(status)) return 0;
    if (this.inWarehouse.has(status)) return 1;
    if (this.onTheWay.has(status)) return 2;
    return 3;
  },
};
